import React from 'react';
import MessageLayout from '../../components/domain/MessageLayout';
import { PageHeader } from '../../components/ui/Primitives';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';

export default function TeacherMessaging() {
  const { user } = useAuth();
  const { messages = [], users = [], addMessage, updateMessage, loading = false } = useData() || {};
  return <div><PageHeader eyebrow="Inbox" title="Messages" description="Direct conversations with students and administrators." /><MessageLayout currentUser={user} role="teacher" messages={messages} users={users} addMessage={addMessage} updateMessage={updateMessage} recipientRoles={['student', 'admin']} loading={loading} /></div>;
}
